// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1a46e01c","455":"1beb5461","977":"d333b414"}[chunkId] + ".chunk.js";
};